module.exports = __webpack_public_path__ + "img/hk_stock.f145d22d.png";